/*
  MilAura : PDP cadeau (modèle product.milaura-cadeau).
  Scène fermé, ouvert, porté : elle ne change que sur geste (toucher ou glisser).
  Spécification : docs/superpowers/specs/2026-10-17-pdp-cadeau-design.md.
*/
(function () {
  'use strict';

  var reduit = Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- Règles pures (tests/milaura-cadeau-comportement.test.mjs) ---------- */

  /* Le bouton d'action annonce la vue de destination. rangs : rang de chaque vue présente
     (0 fermé, 1 ouvert, 2 porté). actions[r - 1] mène à la vue de rang r, actions[2] ramène
     à la vue fermée ; retour ramène à la première vue quand la vue fermée manque. */
  function libelleAction(rangs, courant, actions, retour) {
    var suivant = (courant + 1) % rangs.length;
    if (suivant === 0) return rangs[0] === 0 ? actions[2] : retour;
    return actions[rangs[suivant] - 1];
  }

  /* Ajout groupé : la fiche affichée n'entre que si elle est disponible et absente du panier. */
  function elementsAAjouter(source, sourceDisponible, sourceDansPanier, variantes) {
    var items = [];
    if (source && sourceDisponible && !sourceDansPanier) items.push({ id: source, quantity: 1 });
    variantes.forEach(function (variante) {
      if (variante) items.push({ id: variante, quantity: 1 });
    });
    return items;
  }

  /* Images sous le premier écran (onglets du détail, cartes de la gamme) : rendues avec data-cadeau-src
     et data-cadeau-srcset par snippets/milaura-cadeau-differe.liquid, elles ne sont demandées qu'après
     l'image principale ou au premier geste (LCP mobile du 2026-10-21 : 9,3 s contre 5,7 s pour la V2). */
  function restaurerImages(portee) {
    Array.prototype.forEach.call(portee.querySelectorAll('[data-cadeau-src], [data-cadeau-srcset]'), function (el) {
      /* srcset d'abord : le navigateur choisit la bonne largeur sans télécharger src. */
      if (el.hasAttribute('data-cadeau-srcset')) {
        el.setAttribute('srcset', el.getAttribute('data-cadeau-srcset'));
        el.removeAttribute('data-cadeau-srcset');
      }
      if (el.hasAttribute('data-cadeau-src')) {
        el.setAttribute('src', el.getAttribute('data-cadeau-src'));
        el.removeAttribute('data-cadeau-src');
      }
    });
  }

  function apresImagePrincipale(doc, fenetre, rappel) {
    var fait = false;
    function lancer() {
      if (fait) return;
      fait = true;
      rappel();
    }
    var image = doc.querySelector('.milaura-cadeau-scene__vue.is-active img, .milaura-cadeau-scene__image');
    if (!image || image.complete) {
      lancer();
      return;
    }
    image.addEventListener('load', lancer, { once: true });
    image.addEventListener('error', lancer, { once: true });
    ['load', 'pointerdown', 'keydown', 'scroll'].forEach(function (type) {
      fenetre.addEventListener(type, lancer, { once: true, passive: true });
    });
  }

  /* Points de défilement (2026-10-23). Rang de la photo du trio la plus proche du bord gauche ;
     en butée à droite, la dernière (elle ne peut pas s'aligner à gauche). */
  function rangVisible(decalages, position, max) {
    if (!decalages.length) return 0;
    if (max > 0 && position >= max - 2) return decalages.length - 1;
    var rang = 0;
    decalages.forEach(function (decalage, index) {
      if (Math.abs(decalage - position) < Math.abs(decalages[rang] - position)) rang = index;
    });
    return rang;
  }

  function marquerPoint(points, rang) {
    points.forEach(function (point, index) {
      point.classList.toggle('is-active', index === rang);
    });
  }

  window.MilauraCadeau = {
    libelleAction: libelleAction,
    elementsAAjouter: elementsAAjouter,
    restaurerImages: restaurerImages,
    apresImagePrincipale: apresImagePrincipale,
    rangVisible: rangVisible,
    marquerPoint: marquerPoint
  };

  /* ---------- Scène ---------- */

  function initScene(scene) {
    if (scene.dataset.sceneReady === 'true') return;
    scene.dataset.sceneReady = 'true';

    var vues = Array.prototype.slice.call(scene.querySelectorAll('[data-scene-vue]'));
    if (vues.length < 2) return;

    var fil = scene.querySelector('[data-scene-fil]');
    var etapes = Array.prototype.slice.call(scene.querySelectorAll('[data-scene-etape]'));
    var action = scene.querySelector('[data-scene-action]');
    var annonce = scene.querySelector('[data-scene-annonce]');
    var points = Array.prototype.slice.call(scene.querySelectorAll('[data-scene-point]'));
    var cadre = scene.querySelector('.milaura-cadeau-scene__cadre') || scene;
    var retour = scene.getAttribute('data-action-retour') || '';
    var actions = [];
    try {
      actions = JSON.parse(scene.getAttribute('data-actions') || '[]');
    } catch (erreur) {
      actions = [];
    }

    var courant = 0;
    var occupe = false;

    /* Les vues 2 et 3 arrivent dans des <template> : on les insère après le chargement de la page,
       ou au premier geste, pour laisser toute la bande passante à l'image LCP. */
    function chargerVues() {
      Array.prototype.forEach.call(scene.querySelectorAll('template[data-scene-differe]'), function (modele) {
        modele.replaceWith(modele.content.cloneNode(true));
      });
    }
    if (document.readyState === 'complete') {
      chargerVues();
    } else {
      window.addEventListener('load', chargerVues, { once: true });
    }

    function rangDe(index) {
      return Number(vues[index].getAttribute('data-scene-rang') || index);
    }

    function synchro() {
      etapes.forEach(function (bouton, index) {
        bouton.setAttribute('aria-pressed', String(index === courant));
      });
      marquerPoint(points, courant);
      vues.forEach(function (vue, index) {
        vue.setAttribute('aria-hidden', String(index !== courant));
      });
      var rangs = vues.map(function (vue, index) { return rangDe(index); });
      var libelle = libelleAction(rangs, courant, actions, retour);
      if (action && libelle) action.textContent = libelle;
      if (annonce && etapes[courant]) {
        annonce.textContent = 'Vue ' + (courant + 1) + ' sur ' + vues.length + ' : ' + etapes[courant].textContent.trim();
      }
    }

    function aller(cible) {
      if (cible === courant || occupe || cible < 0 || cible >= vues.length) return;
      chargerVues();
      var depart = vues[courant];
      var arrivee = vues[cible];
      var inverse = cible < courant;

      if (reduit) {
        depart.classList.remove('is-active');
        arrivee.classList.add('is-active');
        courant = cible;
        synchro();
        return;
      }

      occupe = true;
      arrivee.classList.add('is-active', 'is-entering');
      if (inverse) arrivee.classList.add('is-inverse');
      depart.classList.add('is-leaving');
      if (fil) {
        fil.classList.remove('is-bas', 'is-haut');
        void fil.offsetWidth;
        fil.classList.add(inverse ? 'is-haut' : 'is-bas');
      }
      courant = cible;
      synchro();

      var termine = false;
      function fin() {
        if (termine) return;
        termine = true;
        depart.classList.remove('is-active', 'is-leaving');
        arrivee.classList.remove('is-entering', 'is-inverse');
        if (fil) fil.classList.remove('is-bas', 'is-haut');
        occupe = false;
      }
      arrivee.addEventListener('animationend', fin, { once: true });
      window.setTimeout(fin, 1200);
    }

    etapes.forEach(function (bouton) {
      bouton.addEventListener('click', function () {
        aller(Number(bouton.getAttribute('data-scene-etape')));
      });
    });

    if (action) {
      action.addEventListener('click', function () {
        aller((courant + 1) % vues.length);
      });
    }

    /* Les points se touchent aussi ; les libellés restent la commande accessible. */
    points.forEach(function (point, index) {
      point.addEventListener('click', function () {
        aller(index);
      });
    });

    var departX = null;
    cadre.addEventListener('pointerdown', function (evenement) {
      departX = evenement.clientX;
    });
    cadre.addEventListener('pointerup', function (evenement) {
      if (departX === null) return;
      var ecart = evenement.clientX - departX;
      departX = null;
      if (Math.abs(ecart) < 40) return;
      aller(ecart < 0 ? Math.min(vues.length - 1, courant + 1) : Math.max(0, courant - 1));
    });
    cadre.addEventListener('pointercancel', function () {
      departX = null;
    });

    synchro();
  }

  /* ---------- Trio « Au sapin » : points sous les photos qui défilent ---------- */

  function initTrio(trio) {
    if (trio.dataset.trioReady === 'true') return;
    trio.dataset.trioReady = 'true';

    var rangee = trio.parentNode && trio.parentNode.querySelector('[data-trio-points]');
    if (!rangee) return;
    var points = Array.prototype.slice.call(rangee.querySelectorAll('[data-trio-point]'));
    var photos = Array.prototype.slice.call(trio.querySelectorAll('.milaura-cadeau-detail__usage'));

    function decalages() {
      var gauche = trio.getBoundingClientRect().left + (parseFloat(window.getComputedStyle(trio).paddingLeft) || 0);
      return photos.map(function (photo) {
        return photo.getBoundingClientRect().left - gauche + trio.scrollLeft;
      });
    }

    var attente = false;
    trio.addEventListener('scroll', function () {
      if (attente) return;
      attente = true;
      window.requestAnimationFrame(function () {
        attente = false;
        marquerPoint(points, rangVisible(decalages(), trio.scrollLeft, trio.scrollWidth - trio.clientWidth));
      });
    }, { passive: true });

    points.forEach(function (point, index) {
      point.addEventListener('click', function () {
        trio.scrollTo({ left: decalages()[index] || 0, behavior: reduit ? 'auto' : 'smooth' });
      });
    });
  }


  /* ---------- Un écrin pour chacune : schéma de la parure (milaura-recommendations.js, addParure) ---------- */

  function formatPrix(centimes) {
    return (centimes / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function routeJs(route, repli) {
    var base = route || repli;
    return /\.js$/.test(base) ? base : base + '.js';
  }

  function lirePanier() {
    var routes = window.routes || {};
    return fetch(routeJs(routes.cart_url, '/cart.js'), { credentials: 'same-origin' }).then(function (reponse) {
      return reponse.ok ? reponse.json() : null;
    });
  }

  function variantSource() {
    var formulaire = document.querySelector('product-form form[action*="/cart/add"]');
    var champ = formulaire && formulaire.querySelector('[name="id"]');
    return champ ? Number.parseInt(champ.value || '', 10) : 0;
  }

  function initGamme(bloc) {
    if (bloc.dataset.gammeReady === 'true') return;
    bloc.dataset.gammeReady = 'true';

    var rail = bloc.querySelector('[data-cadeau-rail]');
    var compte = bloc.querySelector('[data-milaura-parure-count]');
    var total = bloc.querySelector('[data-milaura-parure-total]');
    var bouton = bloc.querySelector('[data-milaura-parure-add]');
    var statut = bloc.querySelector('[data-milaura-parure-status]');
    var prixSource = Number(bloc.getAttribute('data-prix-source') || 0);
    var libelleSource = bloc.getAttribute('data-libelle-source') || 'Votre cadeau';
    var unite = bloc.getAttribute('data-libelle-unite') || 'cadeau';
    var unites = bloc.getAttribute('data-libelle-unites') || 'cadeaux';
    var sourceDisponible = bloc.getAttribute('data-source-disponible') !== 'false';
    var sourceDansPanier = false;

    Array.prototype.forEach.call(bloc.querySelectorAll('[data-milaura-recommendation-card]'), function (carte) {
      if (carte.querySelector('[data-milaura-parure-check]')) return;
      var nom = (carte.querySelector('.grid__card-title, h3') || {}).textContent || 'ce cadeau';
      nom = nom.replace(/\s+/g, ' ').trim();
      var etiquette = document.createElement('label');
      etiquette.className = 'milaura-parure__check';
      var caseACocher = document.createElement('input');
      caseACocher.type = 'checkbox';
      caseACocher.setAttribute('data-milaura-parure-check', '');
      var epuise = carte.dataset.productAvailable === 'false';
      if (epuise || !carte.dataset.variantId) {
        caseACocher.disabled = true;
        caseACocher.setAttribute('aria-label', nom + ', épuisé');
      } else {
        caseACocher.setAttribute('aria-label', 'Ajouter ' + nom + ' à la sélection');
      }
      etiquette.appendChild(caseACocher);
      carte.dataset.parureCheckable = caseACocher.disabled ? 'false' : 'true';
      carte.prepend(etiquette);
      if (epuise) {
        var mention = document.createElement('span');
        mention.className = 'milaura-cadeau-gamme__epuise';
        mention.textContent = 'Épuisé';
        etiquette.after(mention);
      }
    });

    function cochees() {
      return Array.prototype.filter.call(bloc.querySelectorAll('[data-milaura-parure-check]'), function (c) {
        return c.checked && !c.disabled;
      });
    }

    function resume() {
      var choix = cochees();
      var somme = choix.reduce(function (acc, caseACocher) {
        var carte = caseACocher.closest('[data-milaura-recommendation-card]');
        return acc + Number((carte && carte.dataset.productPrice) || 0);
      }, 0);
      var n = choix.length;
      var nom = n > 1 ? unites : unite;
      if (sourceDansPanier || !sourceDisponible) {
        compte.textContent = n + ' ' + nom;
        total.textContent = formatPrix(somme);
      } else {
        compte.textContent = libelleSource + ' + ' + n + ' ' + nom;
        total.textContent = formatPrix(prixSource + somme);
      }
    }

    function suivrePanier(panier) {
      var source = variantSource();
      sourceDansPanier = Boolean(panier && source && (panier.items || []).some(function (ligne) {
        return Number(ligne.variant_id) === source;
      }));
      resume();
    }

    bloc.addEventListener('change', function (evenement) {
      if (evenement.target.matches('[data-milaura-parure-check]')) resume();
    });

    Array.prototype.forEach.call(bloc.querySelectorAll('[data-cadeau-fleche]'), function (fleche) {
      fleche.addEventListener('click', function () {
        var carte = rail && rail.querySelector('[data-milaura-recommendation-card]');
        if (!carte) return;
        rail.scrollBy({ left: Number(fleche.getAttribute('data-cadeau-fleche')) * (carte.offsetWidth + 12), behavior: reduit ? 'auto' : 'smooth' });
      });
    });

    document.addEventListener('cart:updated', function (evenement) {
      suivrePanier(evenement.detail);
    });

    /* Le bouton principal et le tiroir publient sur le bus de Dawn, sans le panier complet : on le relit. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        lirePanier().then(suivrePanier).catch(function () {});
      });
    }

    if (bouton) {
      bouton.addEventListener('click', function () {
        ajouterGamme();
      });
    }

    function ajouterGamme() {
      if (bouton.getAttribute('aria-busy') === 'true') return;
      var choix = cochees();
      var source = variantSource();
      bouton.setAttribute('aria-busy', 'true');
      if (statut) statut.textContent = '';
      lirePanier()
        .catch(function () { return null; })
        .then(function (panier) {
          suivrePanier(panier);
          var variantes = choix.map(function (caseACocher) {
            var carte = caseACocher.closest('[data-milaura-recommendation-card]');
            return Number.parseInt((carte && carte.dataset.variantId) || '', 10);
          });
          var items = elementsAAjouter(source, sourceDisponible, sourceDansPanier, variantes);
          if (!items.length) {
            if (statut) statut.textContent = 'Cochez au moins un ' + unite + '.';
            return null;
          }
          var tiroir = document.querySelector('cart-drawer');
          var routes = window.routes || {};
          return fetch(routeJs(routes.cart_add_url, '/cart/add'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              items: items,
              sections: tiroir && tiroir.getSectionsToRender ? tiroir.getSectionsToRender().map(function (s) { return s.id; }) : [],
              sections_url: window.location.pathname
            })
          })
            .then(function (reponse) {
              return reponse.json().catch(function () { return null; }).then(function (donnees) {
                if (!reponse.ok || !donnees || donnees.status) throw new Error((donnees && donnees.description) || 'cart_add_' + reponse.status);
                return donnees;
              });
            })
            .then(function (donnees) {
              if (statut) statut.textContent = 'Ajouté au panier';
              if (typeof window.milauraCartToast === 'function') window.milauraCartToast('Ajouté au panier');
              try {
                if (tiroir && tiroir.renderContents) tiroir.renderContents(donnees);
              } catch (erreur) {
                console.error('MilAura cadeau : rafraîchissement du tiroir impossible', erreur);
              }
              choix.forEach(function (caseACocher) { caseACocher.checked = false; });
              return lirePanier();
            })
            .then(function (panier) {
              if (!panier) return;
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: panier }));
              window.dispatchEvent(new CustomEvent('cart:updated', { detail: panier }));
            });
        })
        .catch(function (erreur) {
          console.error('MilAura cadeau : ajout groupé impossible', erreur);
          if (statut) statut.textContent = "L'ajout n'a pas abouti. Réessayez.";
        })
        .then(function () {
          bouton.removeAttribute('aria-busy');
          resume();
        });
    }

    lirePanier().then(suivrePanier).catch(function () { resume(); });
  }

  /* ---------- Démarrage ---------- */

  function initAll(portee) {
    Array.prototype.forEach.call((portee || document).querySelectorAll('[data-milaura-cadeau-scene]'), initScene);
    Array.prototype.forEach.call((portee || document).querySelectorAll('[data-cadeau-trio]'), initTrio);
    Array.prototype.forEach.call((portee || document).querySelectorAll('[data-milaura-cadeau-gamme]'), initGamme);
  }

  function demarrer() {
    initAll(document);
    apresImagePrincipale(document, window, function () {
      restaurerImages(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  document.addEventListener('shopify:section:load', function (evenement) {
    initAll(evenement.target);
    restaurerImages(evenement.target);
  });
})();
